import { CommonModule } from '@angular/common';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class SecurityHeaderDropdownModule {
}
SecurityHeaderDropdownModule.ɵfac = function SecurityHeaderDropdownModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityHeaderDropdownModule)(); };
SecurityHeaderDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SecurityHeaderDropdownModule });
SecurityHeaderDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule] });
